import { useParams } from "react-router-dom";
import QurealSection from "../../../common/QurealSection";
import SectionHeader from "../../../components/commons/SectionHeader";
import { useItemsFine, useSingleItem } from "../../../_actions/app/items";
import { getImageURL, getPublicImageURL } from "../../../_helpers/image";
import styles from "../styles/BrandStyles.module.css";
import React, { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import AddBrandOrganization from "./AddBrandOrganization";
import { useCurrentUser } from "../../../actions/auth";
import log from "cslog";
import {
    Button,
    Checkbox,
    Col,
    Flex,
    Form,
    Grid,
    Input,
    Modal,
    Row,
    Tabs,
    Collapse,
    Select,
    ColorPicker,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import PhotoButton from "../../../qforms/standard_elements/PhotoButton";
import {
    useCreateItem,
    useUpdateItem,
} from "../../../_actions/mutations/items";
import { useHistory } from "react-router-dom";
import { nanoid } from "nanoid";
import snakeCase from "lodash/snakeCase";
import ManageBrandMembers from "./ManageBrandMembers";
import Cstyles from "./style/BrandEditPage.module.css";
import BrandAssetsForm, { BrandThemePalettePicker } from "./BrandAssetsForm";
import ThemeGenerator from "../../../sandbox/ThemeGenerator";
import ProductManager from "./ProductManager";

const { useBreakpoint } = Grid;

function BrandEditPage({ params, isAdmin = false }) {
    console.log("BrandEditPage → isAdmin:", isAdmin);
    const paramsFromRoute = useParams();
    const id = params?.id || paramsFromRoute.id;
    console.log("id: ", id);
    const history = useHistory();
    const {
        isLoading: loadingMe,
        isSuccess: successMe,
        data: dataMe,
    } = useCurrentUser();
    const [show, setShow] = useState(false);

    //   const { data, isSuccess, isLoading } = useSingleItem(
    //     "qdb_organization",
    //     // "filter[owner][_eq]=$CURRENT_USER&fields=*,users.*",
    //     `/${id}?fields=*,users.directus_users_id.first_name,users.directus_users_id.last_name,users.directus_users_id.id,users.directus_users_id.email&filter={"_or":[{"owner":{"_eq":"$CURRENT_USER"}},{"users":{"directus_users_id":{"_eq":"$CURRENT_USER"}}}]}`,
    //     true
    //   );
    const apiUrl = isAdmin
        ? `/${id}?fields=*,users.directus_users_id.first_name,users.role,users.directus_users_id.last_name,users.directus_users_id.id,users.directus_users_id.email`
        : `/${id}?fields=*,users.directus_users_id.first_name,users.role,users.directus_users_id.last_name,users.directus_users_id.id,users.directus_users_id.email&filter={\"_or\":[{\"owner\":{\"_eq\":\"$CURRENT_USER\"}},{\"users\":{\"directus_users_id\":{\"_eq\":\"$CURRENT_USER\"}}}]}`;

    const { data, isSuccess, isLoading } = useSingleItem(
        "qdb_organization",
        apiUrl,
        true
    );

    const goBack = () => {
        history.push("/settings/brands");
    };

    log.d(data, "Brand data");
    const {
        isSuccess: industrySuccess,
        loading: industryLoading,
        data: industryData,
    } = useItemsFine("qdb_industry", "limit=-1&fields=id,name", true);
    const [form] = Form.useForm();
    const mutationCreate = useCreateItem("qdb_organization", () => {
        history.push("/settings/brands");
    });
    const mutationUpdate = useUpdateItem("qdb_organization", id, () => {
        history.push("/settings/brands");
    });
    const [tab, setTab] = useState("info");
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    const is_update = id !== undefined;

    log.d(id, "Brand id");
    log.d(data, "Brand data");

    const addOrganization = (values) => {
        log.d(values, "Person values");
        const new_data = {
            ...values,
            id: is_update ? id : `${snakeCase(values.name)}_${nanoid(5)}`,
            //   owner: dataMe?.id,
            //   users: [{ directus_users_id: dataMe?.id }],
            owner: is_update ? data.owner : dataMe?.id,
            users: is_update ? data.users : [{ directus_users_id: dataMe?.id }],
            is_personal: false,
            logo_square: values.logo_square || values.logo,
            logo_dark: values.logo_dark || values.logo,
        };
        log.d(new_data, "New data");
        // return;
        if (!!id) {
            log.p("Updating organization");
            mutationUpdate.mutate(new_data);
        } else {
            log.p("Creating organization");
            mutationCreate.mutate(new_data);
        }
    };

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading={is_update ? "Update Brand" : "Add New Brand"}
                >
                    <Button key="cancel" onClick={goBack}>
                        Cancel
                    </Button>
                    <Button
                        key="submit"
                        type="primary"
                        onClick={() => form.submit()}
                        loading={
                            mutationCreate.isLoading || mutationUpdate.isLoading
                        }
                    >
                        {is_update ? "Update" : "Create"}
                    </Button>
                </SectionHeader>
            }
        >
            <div
                style={{
                    padding: isMobile ? "16px" : "15px",
                }}
            >
                {/* <p>params: {id}</p> */}
                {/* {isSuccess && <p>{JSON.stringify(data)}</p>} */}
                {/* {isLoading && <p>Loading....</p>}
        {isSuccess && data && data.owner !== dataMe?.id && (
          <p>You are not authorized to edit this brand</p>
        )} */}
                {isSuccess &&
                    data &&
                    !(isAdmin || data.owner === dataMe?.id) && (
                        <p>You are not authorized to edit this brand</p>
                    )}
                {(is_update
                    ? //   ? isSuccess && data && data.owner === dataMe?.id
                      isSuccess &&
                      data &&
                      (isAdmin || data.owner === dataMe?.id)
                    : true) && (
                    <Tabs
                        onChange={(key) => {
                            console.log(key);
                            setTab(key);
                        }}
                        activeKey={tab}
                        // type="card"
                        items={[
                            {
                                label: "Brand Information",
                                key: "info",
                                // children: "Brand info"
                            },
                            {
                                label: "Brand assets & communication",
                                key: "assests",
                                // children: "Brand Members"
                            },
                            {
                                label: "Product & Services",
                                key: "products",
                            },
                            {
                                label: "Manage Members",
                                key: "members",
                                // children: "Brand Members"
                            },
                            {
                                label: "Creations",
                                key: "creations",
                                // children: "Brand Members"
                            },
                        ]}
                    />
                )}
                {isSuccess &&
                    data &&
                    data.owner === dataMe?.id &&
                    tab === "members" && (
                        <ManageBrandMembers id={id} members={data.users} />
                    )}

                {(is_update
                    ? //   ? isSuccess && data && data.owner === dataMe?.id && tab === "info"
                      isSuccess &&
                      data &&
                      (isAdmin || data.owner === dataMe?.id) &&
                      tab === "info"
                    : true) && (
                    <Form
                        layout="vertical"
                        form={form}
                        onFinish={addOrganization}
                        initialValues={{
                            // ...initialValues,
                            ...data,
                            // ...(logo_hori && { logo_horizontal: logo_hori }),
                        }}
                        style={{
                            maxWidth: isMobile ? "100%" : "800px",
                        }}
                    >
                        <Form.Item label="Organization Name" name="name">
                            <Input size={isMobile ? "large" : "middle"} />
                        </Form.Item>

                        <Form.Item
                            label="Organization Description"
                            name="description"
                        >
                            <TextArea
                                rows={4}
                                size={isMobile ? "large" : "middle"}
                            />
                        </Form.Item>
                        <Form.Item label="Tagline" name="tagline">
                            <Input size={isMobile ? "large" : "middle"} />
                        </Form.Item>
                        <Form.Item label="USP" name="USP">
                            <TextArea
                                rows={4}
                                size={isMobile ? "large" : "middle"}
                            />
                        </Form.Item>
                        <Form.Item label="Brand Vibes" name="brand_vibes">
                            <Input size={isMobile ? "large" : "middle"} />
                        </Form.Item>
                        <Form.Item label="Industry" name="industry">
                            <Select
                                placeholder="Select one"
                                loadin={industryLoading}
                                size={isMobile ? "large" : "middle"}
                                options={
                                    industrySuccess && industryData
                                        ? industryData.map((industry) => ({
                                              value: industry.id,
                                              label: industry.name,
                                          }))
                                        : []
                                }
                            />
                        </Form.Item>
                        <Form.Item label="Business Model" name="business_model">
                            <Select
                                placeholder="Select one"
                                size={isMobile ? "large" : "middle"}
                                options={[
                                    { value: "B2B", label: "B2B" },
                                    { value: "B2C", label: "B2C" },
                                    { value: "both", label: "both" },
                                ]}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Target Audience"
                            name="target_audience"
                        >
                            <Input size={isMobile ? "large" : "middle"} />
                        </Form.Item>
                        {/* <Row gutter={[10, 10]}>
                            <Col span={12}>
                                <Form.Item label="Default Logo" name="logo">
                                    <PhotoButton
                                        field={{
                                            collection: "qqq",
                                            field: "logo",
                                        }}
                                        width="220px"
                                        height="100px"
                                        objectFit="contain"
                                        show_placeholder={true}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12}>
                                <Form.Item
                                    label="Square Logo"
                                    name="logo_square"
                                >
                                    <PhotoButton
                                        field={{
                                            collection: "qqq",
                                            field: "logo_square",
                                        }}
                                        height="100px"
                                        width="100px"
                                        objectFit="contain"
                                        show_placeholder={true}
                                    />
                                </Form.Item>
                                <Checkbox
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            log.d(
                                                form.getFieldValue("logo"),
                                                "settintg logo_square to"
                                            );
                                            form.setFieldsValue({
                                                logo_square:
                                                    form.getFieldValue("logo"),
                                                logo_square_old:
                                                    form.getFieldValue(
                                                        "logo_square"
                                                    ),
                                            });
                                        } else {
                                            if (
                                                form.getFieldValue(
                                                    "logo_square"
                                                ) === form.getFieldValue("logo")
                                            ) {
                                                form.setFieldsValue({
                                                    logo_square:
                                                        form.getFieldValue(
                                                            "logo_square_old"
                                                        ) || null,
                                                });
                                            }
                                        }
                                        log.d(
                                            form.getFieldsValue(),
                                            "form values now"
                                        );
                                    }}
                                >
                                    Use same as default logo
                                </Checkbox>
                            </Col>
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    label="Default Logo (for dark background)"
                                    name="logo_dark"
                                >
                                    <PhotoButton
                                        field={{
                                            collection: "qqq",
                                            field: "logo_dark",
                                        }}
                                        width="220px"
                                        height="100px"
                                        objectFit="contain"
                                        show_placeholder={true}
                                        background="black"
                                        enable_remove_bg={true}
                                    />
                                </Form.Item>
                                <Checkbox
                                    style={{ paddingBottom: "10px" }}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            log.d(
                                                form.getFieldValue("logo"),
                                                "settintg logo_dark to"
                                            );
                                            form.setFieldsValue({
                                                logo_dark:
                                                    form.getFieldValue("logo"),
                                                logo_dark_old:
                                                    form.getFieldValue(
                                                        "logo_dark"
                                                    ),
                                            });
                                        } else {
                                            if (
                                                form.getFieldValue(
                                                    "logo_dark"
                                                ) === form.getFieldValue("logo")
                                            ) {
                                                form.setFieldsValue({
                                                    logo_dark:
                                                        form.getFieldValue(
                                                            "logo_dark_old"
                                                        ) || null,
                                                });
                                            }
                                        }
                                        log.d(
                                            form.getFieldsValue(),
                                            "form values now"
                                        );
                                    }}
                                >
                                    Use same as default logo
                                </Checkbox>
                            </Col>
                        </Row> */}

                        {/* <Row gutter={[10, 10]}>
                            <Col span={8} />
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    label="Primary Phone"
                                    name="primary_phone"
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Primary Email"
                                    name="primary_email"
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row> */}
                        {/* <Form.Item label="Address" name="address">
                            <TextArea rows={3} />
                        </Form.Item>
                        <Form.Item label="Website" name="website">
                            <Input />
                        </Form.Item> */}
                        {/* 
                        <Collapse
                            // defaultActiveKey={["1"]}
                            defaultActiveKey={[]}
                            // ghost
                            items={[
                                {
                                    key: "1",
                                    label: "Social Media Handles",
                                    children: (
                                        <div>
                                            <Row gutter={[10, 10]}>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        label="Linkedin Handle"
                                                        name="linkedin_handle"
                                                        help="Mention only handle, not full url"
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        label="Instagram Handle"
                                                        name="instagram_handle"
                                                        help="Mention only handle, not full url"
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[10, 10]}>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        label="Facebook Handle"
                                                        name="facebook_handle"
                                                        help="Mention only handle, not full url"
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        label="YouTube Handle"
                                                        name="youtube_handle"
                                                        help="Mention only handle, not full url"
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[10, 10]}>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        label="Pinterest Handle"
                                                        name="pinterest_handle"
                                                        help="Mention only handle, not full url"
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    ),
                                },
                            ]}
                            style={
                                {
                                    // border: "1px solid red",
                                }
                            }
                        /> */}

                        <Flex
                            gap={8}
                            vertical={isMobile}
                            style={{ marginTop: "15px" }}
                        >
                            <Button
                                key="cancel"
                                onClick={() => {
                                    history.push("/settings/brands");
                                }}
                                block={isMobile}
                                size={isMobile ? "large" : "middle"}
                            >
                                Cancel
                            </Button>
                            <Button
                                key="submit"
                                type="primary"
                                onClick={() => form.submit()}
                                loading={
                                    mutationCreate.isLoading ||
                                    mutationUpdate.isLoading
                                }
                                block={isMobile}
                                size={isMobile ? "large" : "middle"}
                            >
                                {is_update ? "Update" : "Create"}
                            </Button>
                        </Flex>
                    </Form>
                )}

                {(is_update
                    ? //   ? isSuccess && data && data.owner === dataMe?.id && tab === "assests"
                      isSuccess &&
                      data &&
                      (isAdmin || data.owner === dataMe?.id) &&
                      tab === "products"
                    : true) && (
                    <ProductManager org={dataMe?.selected_org?.id} />
                )}
                {(is_update
                    ? //   ? isSuccess && data && data.owner === dataMe?.id && tab === "assests"
                      isSuccess &&
                      data &&
                      (isAdmin || data.owner === dataMe?.id) &&
                      tab === "assests"
                    : true) && (
                    <Form
                        layout="vertical"
                        form={form}
                        onFinish={() => {
                            addOrganization(form.getFieldsValue());
                        }}
                        initialValues={{
                            ...data,
                        }}
                        style={{ maxWidth: isMobile ? "100%" : "800px" }}
                    >
                        <Row gutter={[10, isMobile ? 0 : 10]}>
                            <Col xs={24} sm={12}>
                                <Form.Item label="Default Logo" name="logo">
                                    <PhotoButton
                                        field={{
                                            collection: "qqq",
                                            field: "logo",
                                        }}
                                        width="220px"
                                        height="100px"
                                        objectFit="contain"
                                        show_placeholder={true}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12}>
                                <Form.Item
                                    label="Square Logo"
                                    name="logo_square"
                                >
                                    <PhotoButton
                                        field={{
                                            collection: "qqq",
                                            field: "logo_square",
                                        }}
                                        height="100px"
                                        width="100px"
                                        objectFit="contain"
                                        show_placeholder={true}
                                    />
                                </Form.Item>
                                <Checkbox
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            log.d(
                                                form.getFieldValue("logo"),
                                                "settintg logo_square to"
                                            );
                                            form.setFieldsValue({
                                                logo_square:
                                                    form.getFieldValue("logo"),
                                                logo_square_old:
                                                    form.getFieldValue(
                                                        "logo_square"
                                                    ),
                                            });
                                        } else {
                                            if (
                                                form.getFieldValue(
                                                    "logo_square"
                                                ) === form.getFieldValue("logo")
                                            ) {
                                                form.setFieldsValue({
                                                    logo_square:
                                                        form.getFieldValue(
                                                            "logo_square_old"
                                                        ) || null,
                                                });
                                            }
                                        }
                                        log.d(
                                            form.getFieldsValue(),
                                            "form values now"
                                        );
                                    }}
                                >
                                    Use same as default logo
                                </Checkbox>
                            </Col>
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    label="Default Logo (for dark background)"
                                    name="logo_dark"
                                >
                                    <PhotoButton
                                        field={{
                                            collection: "qqq",
                                            field: "logo_dark",
                                        }}
                                        width="220px"
                                        height="100px"
                                        objectFit="contain"
                                        show_placeholder={true}
                                        background="black"
                                        enable_remove_bg={true}
                                    />
                                </Form.Item>
                                <Checkbox
                                    style={{ paddingBottom: "10px" }}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            log.d(
                                                form.getFieldValue("logo"),
                                                "settintg logo_dark to"
                                            );
                                            form.setFieldsValue({
                                                logo_dark:
                                                    form.getFieldValue("logo"),
                                                logo_dark_old:
                                                    form.getFieldValue(
                                                        "logo_dark"
                                                    ),
                                            });
                                        } else {
                                            if (
                                                form.getFieldValue(
                                                    "logo_dark"
                                                ) === form.getFieldValue("logo")
                                            ) {
                                                form.setFieldsValue({
                                                    logo_dark:
                                                        form.getFieldValue(
                                                            "logo_dark_old"
                                                        ) || null,
                                                });
                                            }
                                        }
                                        log.d(
                                            form.getFieldsValue(),
                                            "form values now"
                                        );
                                    }}
                                >
                                    Use same as default logo
                                </Checkbox>
                            </Col>
                        </Row>
                        <Row gutter={[10, isMobile ? 0 : 10]}>
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    label="Primary Phone"
                                    name="primary_phone"
                                >
                                    <Input
                                        size={isMobile ? "large" : "middle"}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    label="Primary Email"
                                    name="primary_email"
                                >
                                    <Input
                                        size={isMobile ? "large" : "middle"}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item label="Address" name="address">
                            <TextArea
                                rows={3}
                                size={isMobile ? "large" : "middle"}
                            />
                        </Form.Item>
                        <Form.Item label="Website" name="website">
                            <Input size={isMobile ? "large" : "middle"} />
                        </Form.Item>
                        {/* <p>Color</p> */}

                        <Form.Item
                            label="Brand Theme Palette"
                            name="color_palettes"
                            tooltip="Select colors for your brand palette"
                            style={{ display: "none" }}
                        >
                            {/* <ThemeGenerator
                                trigger={<Button>Generate Theme</Button>}
                            /> */}
                        </Form.Item>
                        <Form.Item
                            label="Brand Colors"
                            name="brand_colors"
                            tooltip="Select colors for your brand palette"
                        >
                            <BrandThemePalettePicker
                                onChangeThemes={(new_theme_arr) => {
                                    log.d(new_theme_arr, "new_theme_arr");
                                    form.setFieldValue(
                                        "color_palettes",
                                        new_theme_arr
                                    );
                                    form.setFieldsValue({
                                        color_palettes: new_theme_arr,
                                    });
                                    log.d(
                                        form.getFieldsValue(),
                                        "form values now"
                                    );
                                }}
                            />
                        </Form.Item>
                        {/* <Form.Item
                            label="Brand Colors"
                            name="brand_colors"
                            tooltip="Select colors for your brand palette"
                        >
                            <BrandColorPicker />
                        </Form.Item> */}
                        <Collapse
                            // defaultActiveKey={["1"]}
                            defaultActiveKey={[]}
                            // ghost
                            items={[
                                {
                                    key: "1",
                                    label: "Social Media Handles",
                                    children: (
                                        <div>
                                            <Row gutter={[10, 10]}>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        label="Linkedin Handle"
                                                        name="linkedin_handle"
                                                        help="Mention only handle, not full url"
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        label="Instagram Handle"
                                                        name="instagram_handle"
                                                        help="Mention only handle, not full url"
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[10, 10]}>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        label="Facebook Handle"
                                                        name="facebook_handle"
                                                        help="Mention only handle, not full url"
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        label="YouTube Handle"
                                                        name="youtube_handle"
                                                        help="Mention only handle, not full url"
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[10, 10]}>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        label="Pinterest Handle"
                                                        name="pinterest_handle"
                                                        help="Mention only handle, not full url"
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    ),
                                },
                            ]}
                            style={
                                {
                                    // border: "1px solid red",
                                }
                            }
                        />
                        <Flex
                            gap={8}
                            vertical={isMobile}
                            style={{ marginTop: "15px" }}
                        >
                            <Button
                                key="cancel"
                                onClick={() => {
                                    history.push("/settings/brands");
                                }}
                                block={isMobile}
                                size={isMobile ? "large" : "middle"}
                            >
                                Cancel
                            </Button>
                            <Button
                                key="submit"
                                type="primary"
                                onClick={() => form.submit()}
                                loading={
                                    mutationCreate.isLoading ||
                                    mutationUpdate.isLoading
                                }
                                block={isMobile}
                                size={isMobile ? "large" : "middle"}
                            >
                                {is_update ? "Update" : "Create"}
                            </Button>
                        </Flex>
                    </Form>
                )}
            </div>
        </QurealSection>
    );
}

export default BrandEditPage;
